export default __webpack_public_path__ + "static/media/8.a7b8e28a.webp";